import script from "./ObjetivesRowDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjetivesRowDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ObjetivesRowDashboard.vue?vue&type=style&index=0&id=d53ee054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d53ee054"]])

export default __exports__